import v1 from './requests/v1'

export default {
  v1
}